const configurationCenter = {
  // 数据权限配置-权限树查询
  configListPage: {
    type: 'post',
    url: '/ec-pc-api/auth/config/listPage'
  },
  // 数据权限配置-权限配置新增编辑
  configAddConfig: {
    type: 'post',
    url: '/ec-pc-api/auth/config/addConfig'
  },
  // 数据权限配置-权限树查询
  rolePageInfo: {
    type: 'post',
    url: '/qu-platform-manage-api/role/pageInfo'
  },
  // 调试国补类型查询
  queryStateSubsidiesType: {
    type: 'get',
    url: '/ec-pc-api/stateSubsidies/queryStateSubsidiesType'
  },
  // 查询所有店铺
  queryStoreList: {
    type: 'get',
    url: '/ec-pc-api/stateSubsidies/queryStoreList'
  },
  // 国补类型配置分页查询
  stateSubsidiesPage: {
    type: 'post',
    url: '/ec-pc-api/stateSubsidies/stateSubsidiesPage'
  },
  // 国补配置新增-编辑
  stateSubsidiesSave: {
    type: 'post',
    url: '/ec-pc-api/stateSubsidies/stateSubsidiesSave'
  },
  // 删除国补类型配置
  deleteStateSubsidies: {
    type: 'post',
    url: '/ec-pc-api/stateSubsidies/deleteStateSubsidies'
  },
  // 国补订单分页查询
  orderPageQuery: {
    type: 'post',
    url: '/ec-pc-api/stateSubsidies/orderPageQuery'
  },
  // 国补订单删除
  deleteOrder: {
    type: 'post',
    url: '/ec-pc-api/stateSubsidies/deleteOrder'
  },
  // 新品上架店铺管理-列表
  storeManagePage: {
    type: 'post',
    url: '/ec-goods-new-api/storeManage/page'
  },
  // 新品上架店铺管理-保存
  storeManageSave: {
    type: 'post',
    url: '/ec-goods-new-api/storeManage/saveStoreManage'
  },
  // 新品上架店铺管理-用户查询
  storeManageUserPage: {
    type: 'post',
    url: '/ec-goods-new-api/storeManage/userPage'
  },
  // 平台发货周期-删除
  planSendDelete: {
    type: 'post',
    url: '/ec-goods-new-api/planSend/delete'
  },
  // 平台发货周期-列表查询
  planSendPage: {
    type: 'post',
    url: '/ec-goods-new-api/planSend/page'
  },
  // 平台发货周期-保存
  planSendSave: {
    type: 'post',
    url: '/ec-goods-new-api/planSend/saveOrUpdate'
  },
  //达播名称查询
  queryAuthorName: {
    type: 'get',
    url: '/ec-pc-api/livePrice/queryAuthorName'
  },
  //达播控价期配置分页
  authorPricePage: {
    type: 'post',
    url: '/ec-pc-api/livePrice/authorPricePage'
  },
  //达播控价周期配置新增-编辑
  authorPeriodSave: {
    type: 'post',
    url: '/ec-pc-api/livePrice/authorPeriodSave'
  },
  //删除达播控价周期
  deleteAuthorPrice: {
    type: 'get',
    url: '/ec-pc-api/livePrice/deleteAuthorPrice'
  },
};

export default configurationCenter;
